/* unplugin-vue-components disabled */import { render } from "./c-swiper.vue?vue&type=template&id=00907430&scoped=true"
import script from "./c-swiper.vue?vue&type=script&lang=js"
export * from "./c-swiper.vue?vue&type=script&lang=js"

import "./c-swiper.vue?vue&type=style&index=0&id=00907430&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00907430"]])

export default __exports__